import { CommonResponse } from '@/types';
import { httpRequest } from '@/utils/request';
import { request } from 'src/utils/request';

export function getHomePageInfo<T>() {
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/home-page',
    method: 'get',
  });
}

export async function getDeviceMessage(data: {
  metricsType: string; // 支持1h、24h、1week
  startTime: number; // 开始时间
  endTime: number; // 结束时间
}) {
  return request<CommonResponse<{ count: number; time: string }[]>>(`/api/v1/devices-message`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
}

export async function getCurrent() {
  return request<
    CommonResponse<{
      procs: number;
      load1: number; // 1分钟负载率
      load5: number; // 5分钟负载率
      load15: number; // 15分钟负载率
      loadUsagePercent: number; // 负载率
      loadInfo: string;
      cpuUsedPercent: number; // cpu使用率
      cpuUsed: number; // cpu已用
      cpuTotal: number; // cpu总数
      memoryTotal: string; // 内存总量
      memoryAvailable: string; // 内存可用
      memoryUsed: string; // 内存已用
      memoryUsedPercent: number; // 内存使用率
      diskTotal: string; // 磁盘总量
      diskUsed: string; // 磁盘已用
      diskFree: string; // 磁盘剩余
      diskUsedPercent: number; // 磁盘使用率
    }>
  >(`/api/v1/current`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export async function getDeviceTopMessage(number: number = 5) {
  return request<
    CommonResponse<
      {
        id: string;
        device_name: string;
        count: number;
      }[]
    >
  >(`/api/v1/devices/topMessage?number=${number}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export async function getAlertBoard() {
  return request<
    CommonResponse<{
      alert_list: Array<{
        alert_list_id: string;
        alert_name: string;
        device_name: string;
        trigger_time: number;
        trigger_format_time_ago: string;
        alert_level: string;
      }>;
      alert_plate: {
        提示?: number;
        次要?: number;
        紧急?: number;
        重要?: number;
      };
    }>
  >(`/api/v1/device/alert/board`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export async function deleteAlertList(alertListId: string) {
  return request<CommonResponse<any>>(`/api/v1/alert-list/${alertListId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export async function getDriverDeviceNumBoard() {
  return request<
    CommonResponse<
      {
        driver_name: string;
        count: number;
      }[]
    >
  >(`/api/v1/driver-device/num/board`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}


export async function getCurrentLoadUsagePercent() {
  return request<
    CommonResponse<
      {
        "load": number,
        "time": number
      }
    >
  >(`/api/v1/current/loadUsagePercent`, {
    method: 'GET',
  });
}